import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { matchPath } from 'react-router-dom';

import config from '../config';
import { sessionStorageService, useSessionStorage } from '../utils/storageUtils';
import { userAllowedRoutesSelector } from './store/selectors';
import Routes from '../routes';

const EXCLUDED_REDIRECT_PATHS = [
  Routes.ACCESS_DENIED,
  Routes.LOGOUT,
  Routes.MAINTENANCE,
  Routes.SESSION_EXPIRED,
];

export const savePathToRedirectAfterLoginIfValid = () => {
  const currentPath = window.location.pathname;

  // If on error/special pages, redirect to home instead of returning to the error page
  if (EXCLUDED_REDIRECT_PATHS.some(excludedPath => currentPath.endsWith(excludedPath))) {
    sessionStorageService.setItem(config.storageKeys.redirectToAfterLogin, {
      path: Routes.ROOT,
    });
    return;
  }

  // For normal routes, save current path to restore after re-authentication
  sessionStorageService.setItem(config.storageKeys.redirectToAfterLogin, {
    path: currentPath,
    search: window.location.search,
  });
};


const isRouteMatched = (route: string, expectedRoute: string) => !!matchPath(route, {
  path: expectedRoute,
  exact: true,
  strict: true,
});

type SavedRedirect = {
  path: string,
  search?: string
}

export const RedirectAfterLoginIfSaved: FC = () => {
  const history = useHistory();
  const [redirectTo, setRedirectTo] = useSessionStorage<SavedRedirect| null>(config.storageKeys.redirectToAfterLogin);
  const userAllowedRoutes = useSelector(userAllowedRoutesSelector);

  useEffect(() => {
    if (redirectTo && typeof redirectTo === 'object' && redirectTo.path
      && typeof redirectTo.path === 'string' && redirectTo.path !== Routes.LOGOUT) {
      if (userAllowedRoutes.some(route => isRouteMatched(redirectTo.path, route))) {
        setRedirectTo(null);
        history.replace(`${redirectTo.path}${redirectTo.search || ''}`);
      }
    } else if (redirectTo !== null && typeof redirectTo !== 'undefined') {
      setRedirectTo(null);
    }
  }, [redirectTo, history, setRedirectTo, userAllowedRoutes]);

  return null;
};
